"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gridlist = require("@react-aria/gridlist");
var _focus = require("@react-aria/focus");
var _list = require("@react-stately/list");
var _collections = require("@react-stately/collections");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _SelectionList = require("./SelectionList.styled");
var _jsxRuntime = require("react/jsx-runtime");
var StyledContent = _styledComponents.default.div.withConfig({
  displayName: "SelectionList__StyledContent",
  componentId: "sc-1yhvc68-0"
})(["", ";border-color:", ";height:inherit;flex:1;"], _SelectionList.selectionListCss, _tokens.default.sky.sys.color.border.decorative);
var RowContainer = _styledComponents.default.div.withConfig({
  displayName: "SelectionList__RowContainer",
  componentId: "sc-1yhvc68-1"
})(["display:flex;flex-direction:row;> :not(:first-child){border-left:none;border-bottom-left-radius:0;border-top-left-radius:0;}> :not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0;}"]);
var StyledItem = _styledComponents.default.div.withConfig({
  displayName: "SelectionList__StyledItem",
  componentId: "sc-1yhvc68-2"
})(["", ""], _SelectionList.selectableItemCss);
var ListItem = function ListItem(_ref) {
  var item = _ref.item,
    state = _ref.state;
  var ref = _react.default.useRef(null);
  var _ref2 = (0, _gridlist.useGridListItem)({
      node: item
    }, state, ref),
    rowProps = _ref2.rowProps,
    gridCellProps = _ref2.gridCellProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: 'focus-ring',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({}, rowProps, {
      ref: ref,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledItem, _objectSpread({}, gridCellProps, {
        "data-cy": item.props['data-cy'],
        children: item.rendered
      }))
    }))
  });
};
var SelectionList = function SelectionList(ariaProps) {
  var state = (0, _list.useListState)(ariaProps);
  var items = (0, _react.useMemo)(function () {
    return _toConsumableArray(state.collection);
  }, [state.collection]);
  var ref = (0, _react.useRef)(null);
  var _ref3 = (0, _gridlist.useGridList)(ariaProps, state, ref),
    gridProps = _ref3.gridProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContent, _objectSpread({}, gridProps, {
    ref: ref,
    children: items.map(function (item) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ListItem, {
        item: item,
        state: state
      }, item.key);
    })
  }));
};
SelectionList.RowContainer = RowContainer;
SelectionList.Item = _collections.Item;
var _default = exports.default = SelectionList;